import React from 'react'
import {Flex, Text, Img, useStyleConfig, Link as ChakraLink} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {CutleryIcon, ChronoIcon} from '../../icons'
import {Link} from 'react-router-dom'
import {FormattedMessage} from 'react-intl'

export const RecipeTile = ({title, uid, imageData, difficulty, timeToComplete, gridView}) => {
    const styles = useStyleConfig('RecipeTile')

    const damImage = imageData
    const recipeUrl =
        uid && title ? `/r/recipes/${title.replace(/[\s']+/g, '-').toLowerCase()}/${uid}` : '#'

    return (
        <Flex {...styles?.recipeContainer}>
            <ChakraLink
                as={Link}
                to={recipeUrl}
                {...styles?.imageContainer}
                _hover={{textDecoration: 'none'}}
                display="flex"
            >
                <Img {...styles?.imageObject} src={damImage} alt={title} />
            </ChakraLink>
            <Flex {...styles?.textsContainer}>
                <ChakraLink
                    as={Link}
                    to={recipeUrl}
                    {...styles?.titleText}
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    }}
                    _hover={{textDecoration: 'none'}}
                >
                    {title}
                </ChakraLink>
                <Flex {...styles?.extraContainer} flexDir={gridView ? 'column' : 'row'}>
                    {difficulty && (
                        <Flex {...styles?.infoContainer}>
                            <CutleryIcon {...styles?.iconConfig} />{' '}
                            <Text {...styles?.infoText}>{difficulty}</Text>
                        </Flex>
                    )}
                    {timeToComplete && (
                        <Flex {...styles?.infoContainer}>
                            <ChronoIcon {...styles?.iconConfig} />{' '}
                            <Text {...styles?.infoText}>
                                {timeToComplete}{' '}
                                <FormattedMessage
                                    id="recipes.listing_page.recipe_tile.time_to_complete_time.text"
                                    defaultMessage="min"
                                />
                            </Text>
                        </Flex>
                    )}
                </Flex>
            </Flex>
        </Flex>
    )
}

RecipeTile.propTypes = {
    title: PropTypes.string,
    uid: PropTypes.string,
    imageData: PropTypes.string,
    difficulty: PropTypes.string,
    timeToComplete: PropTypes.string,
    gridView: PropTypes.bool,
}
